// extracted by mini-css-extract-plugin
export default {"modal":"pbQO2dNdbeMa_JuOWKMN"};